import React from 'react';
import { Helmet } from "react-helmet";
// import _get from 'lodash/get';
import '../../City/EditCity/style.css';
import EmptyMessage from 'components/EmptyMessage/EmptyMessage';
import Col from 'react-bootstrap/Col';
import Footer from 'components/Footer/Footer';
import Button from 'components/Button/Button';
// import ChannelImage from 'Assets/city-hero.png';
import ChannelInfo from 'pages/Channels/ChannelInfo/ChannelInfo';
import ManageBanner from 'components/Banner/ManageBanner';
import { org_friendly_url, owner_perms, organization_user_access_level, apiUrl, myHeaders_With_Cache_Control, user_entity_uuid, user_access_token, user_access_level, user_Status_Ver } from "Api/Api";
// , myHeaders_Auth_With_Cache_Control
import axios from "axios";
// import { origin } from 'utils/Helper';
//import ChannelEventList from 'pages/Channels/ChannelInfo/ChannelEventList';
import EventList from 'components/EventListTable/EventList';
import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';
// import presentation from 'Assets/presentation-deck.svg';
// import users from 'Assets/users.svg';
// import eye from 'Assets/eye.svg';
import { withRouter, NavLink } from "react-router-dom";
import { local_routes } from 'utils/Routes';
import home from 'Assets/home.svg';
import { Redirect } from 'react-router-dom';
import Venues from 'pages/Channels/ChannelInfo/ChannelVenue';

//let channelUid;
//let friendlyUrl = '';

class EditChannel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            channel_data: {},
            pageLoader: true,
            allowed: true,
            currentTab: null,
        };
        /*
        if (props.match.params.otherpage) {
            if (props.match.params.otherpage === `main`) {
                this.state.currentTab = "main";
            } else if (props.match.params.otherpage === `events`) {
                this.state.currentTab = "events";
            } else if (props.match.params.otherpage === `venues`) {
                this.state.currentTab = "venues";
            } else {
                // bad tab!
            }
        }
        */
        this.workspace_base_url = "";
        //const { match: { params: { org_friendly_url } = {} } = {} } = this.props;
        if (org_friendly_url) {
            this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
            local_routes.channels = local_routes.teams;
            local_routes.managechannel = local_routes.manageteam;
        }
        
        /*
        this.channel_uuid = "";
        const { match: { params: { channel_uuid } = {} } = {} } = this.props;
        if (channel_uuid) {
          this.channel_uuid = channel_uuid;
        }
        */
        this.user_data = {};
        
        if (props.match.params.otherpage) {
            this.state.currentTab = props.match.params.otherpage;
        }
    }

    /*
    componentWillMount() {
        const { match } = this.props;
        friendlyUrl = _get(match, 'params.friendly_url', '');
    }
    */

    componentDidUpdate(prevProps) {
        let { location: { pathname } } = this.props;

        if (prevProps.location.pathname === pathname) return;
        this.routeChanged();
    }

    routeChanged() {
        if (this.props.match.params.otherpage) {
            if (this.props.match.params.otherpage === `main`) {
                this.setState({ currentTab: "main" })
            } else if (this.props.match.params.otherpage === `events`) {
                this.setState({ currentTab: "events" })
            } else if (this.props.match.params.otherpage === `venues`) {
                this.setState({ currentTab: "venues" })
            } else {
                // bad tab!
                this.setState({ currentTab: null });
            }
        } else {
            // no tab!
            this.setState({ currentTab: null });
        }

    }

    componentDidMount = async function () {
        window.scrollTo(0, 0);
        const { match: { params: { friendly_url } = {} } = {} } = this.props;
        /*
        if(this.props && this.props.location && this.props.location.data === "eventTab")
        {
          this.setState({currentTab:"profile"})
        }
        */

        //channelUid = this.props.match.params.friendly_url;

        if (!user_access_token || user_Status_Ver !== "1") {
            this.setState({ allowed: false });
            return;
        }
        let allowed = false;
        if (user_access_level === "admin") {
            // allowed
            allowed = true;
        }
        if (organization_user_access_level === "admin") {
            // allowed
            allowed = true;
        }
        if (owner_perms['channels'] && owner_perms['channels'][friendly_url] && owner_perms['channels'][friendly_url] === "admin") {
            // allowed
            allowed = true;
        }
        if (!allowed) {
            console.error("User not allowed to manage channel");
            this.setState({ allowed: false });
            return;
        }
        
        /*
        let entityOwner=null;
        let owner_users_response = await axios.get(`${apiUrl}channels/${friendlyUrl.toLowerCase()}/users`, myHeaders_Auth_With_Cache_Control);
        if(owner_users_response.data){
            owner_users_response.data.forEach((item)=>{
                if(item.xref_data && item.xref_data.entity_owner_integer && item.xref_data.entity_owner_integer >= 1){
                    entityOwner=item.xref_data.entity_owner_integer
                }
            })
        }
        // || (user_access_level !== "channel_admin" && entityOwner)
        if (user_access_level !== "admin" && (user_access_level !== "channel_admin" && entityOwner)) {
            try {
                let loc_users_response = await axios.get(`${apiUrl}channels/${friendlyUrl.toLowerCase()}/users`, myHeaders_Auth_With_Cache_Control);
                let owner_match = false;
                for (let pk_user of loc_users_response.data) {
                    if (pk_user.entity_uuid === user_entity_uuid) {
                        if (pk_user.xref_data && pk_user.xref_data.entity_owner_integer && pk_user.xref_data.entity_owner_integer >= 1) {
                            owner_match = true;
                            // this.setState({pageLoader:false})
                            break;
                        }
                    }
                }
                if (!owner_match) {
                    this.setState({
                        allowed: false,
                        pageLoader: false
                    });
                    return;
                }
            } catch (err) {
                this.setState({ allowed: false, pageLoader: false });
                return;
            }
        }
        */
        
        try {
            let [channel_data_response,user_data_response,user_location_data_response] = await Promise.all([
                axios.get(`${apiUrl}channels/${friendly_url}`, myHeaders_With_Cache_Control),
                axios.get(`${apiUrl}users/${user_entity_uuid}`, myHeaders_With_Cache_Control),
                //axios.get(`${apiUrl}users/${user_entity_uuid}/locations.audience?filter[resident_integer][gte]=1`, myHeaders_With_Cache_Control),
                axios.get(`${apiUrl}users/${user_entity_uuid}/locations.audience?filter_obj=${encodeURIComponent('{"resident_integer":{"gte":1}}')}`, myHeaders_With_Cache_Control),
            ]);
            this.user_data = user_data_response.data;
            this.user_data.locations = user_location_data_response.data;
            //org_data_response.data.channels = channels_data_response.data;
            
            this.setState({ channel_data:channel_data_response.data, pageLoader: false});
        } catch (err) {
            this.setState({ pageLoader: false });
            return;
        }
        
        this.routeChanged();        
        
        /*
        let userDataRes = await axios.get(`${apiUrl}channels/${friendlyUrl.toLowerCase()}`, myHeaders_With_Cache_Control)
        
        if (userDataRes.data) {
            try {
                let recDataRes = userDataRes.data
                let imageData = await axios.get(`${apiUrl}channels/${recDataRes.entity_uuid}`, myHeaders_With_Cache_Control)
                if (imageData.data) {
                    this.setState({ channel_name: imageData.data.entity_name })
                }
                // const wideEventImg = _get(imageData, 'data.city_skyline_wide_image_url', '');
                const eventImg = _get(imageData, 'data.logo_image_url', '');
                // set the all api data
                this.setState({ eventImg: eventImg, pageLoader: false, });
            }
            catch (err) {
                this.setState({ pageLoader: false });
                return;
            }
        }
        */
    }

    bannerApiImage = () => {
        //const { channel_name, eventImg, OrganizerArr } = this.state;
        //const { match } = this.props;
        //const friendlyUrl = _get(match, 'params.friendly_url', '');
        let bannerImageUrl = "";
        if (this.state.channel_data.logo_image_url) {
            let url = this.state.channel_data.logo_image_url;
            let array = url.split("/");
            bannerImageUrl = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padblack_900x360/${array[5]}`;
        }
        return (
            <div>
                <div className="eventImage city-chicago">
                    { bannerImageUrl &&
                        <img src={bannerImageUrl} className="city-img" alt="img" />
                    }
                    <div className="container contentPosition">
                        <div className="city-name">
                            <h1 className="cityName">{this.state.channel_data.entity_name}</h1>
                        </div>
                        { this.state.channel_data.status_code === 1 &&
                        <NavLink to={`${this.workspace_base_url}${local_routes.channels}/${this.state.channel_data.friendly_url}`}>
                            <Button theme="btn-global btn-green Form_Btn_Pad font-normal marTop5 back-cityBtn">
                                Back to Channel
                            </Button>
                        </NavLink>
                        }
                    </div>
                </div>
            </div>
        );
    }
    
    /*
    // Banner section Start
    bannerApiImage = () => {
        const { channel_name, eventImg, OrganizerArr } = this.state;
        const { match } = this.props;
        const friendlyUrl = _get(match, 'params.friendly_url', '');
        let url = eventImg;
        let array = url.split("/");
        let bannerImageUrl = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padblack_900x360/${array[5]}`;
        return (
            <div>
                <div className="eventImage city-chicago">
                    <img src={bannerImageUrl} className="city-img" alt="img" />
                    <div className="container contentPosition">
                        <div className="city-name">
                            <h1 className="cityName">{channel_name !== undefined && !null && channel_name}</h1>
                        </div>
                        {OrganizerArr > 0 ?
                            <div className="citySignUp">
                                <h4>This Channel is Open - Sign Up</h4>
                                <p>If you think you have what is takes to run PechKucha Nights in your channel, apply to become
                                  the official organizer! Join the celebration of creativity by becoming part of our global network of volunteers
                                  and put your channel's creative talent and hidden heroes on the world stage!</p>
                                <Button theme="btn-global btn-green Form_Btn_Pad font-normal marTop5" OnClickMet={this.OnClickClaimBtn}>
                                    Claim Channel
                                </Button>
                            </div>
                            : null
                        }
                        <NavLink to={`${this.workspace_base_url}${local_routes.channels}/${friendlyUrl}`}>
                            <Button theme="btn-global btn-green Form_Btn_Pad font-normal marTop5 back-cityBtn">
                                Back to Channel
                            </Button>
                        </NavLink>
                    </div>
                </div>
            </div>
        );
    }
    */
    
    /*
    bannerApiImageEmpty = () => {
        const { channel_name } = this.state;
        const { match } = this.props;
        const friendlyUrl = _get(match, 'params.friendly_url', '');
        return (
            <div>
                <div className="bannerEventImage city-chicago">
                    <img src={ChannelImage} className="city-img" alt="img" />
                    <div className="container contentPosition">
                        <h1 className="cityName">{channel_name}</h1>
                        <NavLink
                            to={`${this.workspace_base_url}${local_routes.channels}/${friendlyUrl}`}
                        >
                            <Button theme="btn-global Form_Btn_Pad font-normal marTop5 back-cityBtn">
                                Back to Channel
                            </Button>
                        </NavLink>
                    </div>
                </div>
            </div>
        );
    }
    */
    // Banner section End

    render() {
        const { match: { params: { friendly_url } = {} } = {} } = this.props;
        const { currentTab, allowed, pageLoader, eventImg } = this.state;

        if (!allowed) {
            return (
                <div className="empty-msg">
                    <EmptyMessage empty_message="Not allowed to edit this channel" />
                </div>
            );
        }

        if (!currentTab) {
            return (
                <Redirect to={`${this.workspace_base_url}${local_routes.managechannel}/${friendly_url}/main`} />
            );
        }

        if (pageLoader) {
            return (
                <FullPageSpinner />
            );
        }

        return (
            <React.Fragment>
                <Helmet>
                    <title>Edit PechaKucha Channel</title>
                    <meta name="robots" content="noindex" />
                </Helmet>
                <React.Fragment>
                    <div className="main-section editCityData">
                        {/* Banner section starts */}
                        <ManageBanner
                          entity_name={this.state.channel_data.entity_name}
                          carousel_images={[this.state.channel_data.logo_image_url]}
                          back_link={local_routes.channels+'/'+friendly_url}
                        />
                        {/*
                        <div>
                            {this.bannerApiImage()}
                        </div>
                        */}
                        {/* Banner section Ends */}
                        <div className="editCityBg">
                            <div className="container editCityMenu">
                                <Col lg={12} className="pad-mb0 pad0">
                                    <div>
                                        <div className="sub-menu-nav" style={{borderBottom: "medium none"}}>
                                            <ul>
                                                <li><NavLink activeStyle={{ color: "#D12F50" }} to={`${this.workspace_base_url}${local_routes.managechannel}/${friendly_url}/main`}>INFO</NavLink></li>
                                                <li><NavLink activeStyle={{ color: "#D12F50" }} to={`${this.workspace_base_url}${local_routes.managechannel}/${friendly_url}/events`}>EVENTS</NavLink></li>
                                                <li><NavLink activeStyle={{ color: "#D12F50" }} to={`${this.workspace_base_url}${local_routes.managechannel}/${friendly_url}/venues`}>VENUES</NavLink></li>
                                            </ul>
                                        </div>
                                        {this.state.currentTab === 'main' &&
                                            <ChannelInfo user_data={this.user_data} channel_data={this.state.channel_data} {...this.props} />
                                        }
                                        {this.state.currentTab === 'events' &&
                                            <EventList
                                                //user_data={this.user_data}
                                                source_info={{...this.state.channel_data,entity_type:'channels'}}
                                                referrer={`${this.workspace_base_url}${local_routes.managechannel}/${this.state.channel_data.friendly_url}/events`}
                                            />
                                        }
                                        {this.state.currentTab === 'venues' &&
                                            <Venues user_data={this.user_data} channel_data={this.state.channel_data} {...this.props} />
                                        }
                                    </div>
                                </Col>
                            </div>
                        </div>
                        {/* Banner sub navigation starts */}
                        {/* Banner sub navigation ends */}
                        <Footer
                            homeImg={home}
                            homeImgRef="/"
                            breadcrumbMainPage="Channel"
                            breadcrumbSubPage="Manage Channel"
                            mainPageLink={`${this.workspace_base_url}${local_routes.channels}/${this.state.channel_data.friendly_url}`} />
                    </div>
                </React.Fragment>
            </React.Fragment>
        );
    }
}

export default withRouter(EditChannel);

